import React, {Fragment, useContext, useMemo} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {setLookActiveFeature} from "../../../../../actions/lookFunctions";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {getFeatureOptions} from "../../lookFunctions";
import {getCurrentLayout} from "../../../../appLayout";

import LookWizardContext from "./lookWizardContext";
import LookWizardContentFinalPrice from "./lookWizardContentFinalPrice";
import GroheFeatureLockedBadge from "../../../grohe/groheNavigation/groheFeature/groheFeatureLockedBadge";
import GroheFeatureNotInVisualizer from "../../../grohe/groheNavigation/groheFeature/groheFeatureNotInVisualizer";
import LookFeatureOptions from "../lookFeature/lookFeatureOptions";
import GroheFeatureOptions from "../../../grohe/groheNavigation/groheFeature/groheFeatureOptions";
import LookFeatureColorMatch from "../lookFeature/lookFeatureColorMatch";
import LookFeatureRemoveButton from "../lookFeatureRemoveButton";
import LookFeatureImage from "../lookFeature/lookFeatureImage";
import FeatureName from "../../../../visComponents/featureName";
import LookFeatureSku from "../lookFeature/lookFeatureSku";
import LookFeatureNotInStock from "../lookFeature/lookFeatureNotInStock";
import FeatureDescription from "../../../../visComponents/featureDescription";
import GroheFeatureQuantity from "../../../grohe/groheNavigation/groheFeature/groheFeatureQuantity";
import LookFeaturePairPrice from "../lookListFeature/lookFeaturePairPrice";
import GroheFeatureSQFTButton from "../../../grohe/groheNavigation/groheFeature/groheFeatureSQFTButton";
import {isInStock} from "../../lookFunctions2";


const LookWizardContentFeature = (props) => {

  // const {wizardActiveStep, wizardSelectedValues} = props;
  const {filterGroups, showMatchColor} = props;

  // const {wizardGroup, isCompletedStep, selectedWizardFeature, isSingleFeature} = useContext(LookWizardContext);
  const {wizardGroup, isCompletedStep, selectedWizardFeature} = useContext(LookWizardContext);

  const feature = selectedWizardFeature;

  const showPriceLocked = getFeatureIsLocked(feature);

  const layout = getCurrentLayout();

  const showPrice = !!layout.partIdExistInQtCategory(feature.partId, true);
  const colorOptions = useMemo(() => getFeatureOptions(feature, filterGroups), [feature, filterGroups]);
  const featureIsInStock = useMemo(() => isInStock(feature), [feature]);

  const showQuantityInput = !wizardGroup.multipleAddToCart && !showPrice && !feature.dbFeature.hideQuantity;
  const showPriceInput = !wizardGroup.multipleAddToCart && showPrice && !feature.dbFeature.hideQuantity;

  return (
    <div className="lw-content__other pt-075">
      <div className={"grohe-feature grohe-wizard__feature h-auto"
        + (colorOptions && colorOptions.length ? " grohe-wizard__feature--with-options" : "")}>
        <LookFeatureImage forFeature={feature}/>
        {showPriceLocked ? (
          <GroheFeatureLockedBadge/>
        ) : (
          <Fragment>
            <div className="lk-title mt-1">
              <h2 className="lk-title__text h-auto"><FeatureName feature={feature} useCollectionName={true}/></h2>
            </div>
            <p className="lm-feature__content-model">
              <LookFeatureSku lookFeature={feature}/>
              <LookFeatureNotInStock lookFeature={feature}/>
            </p>
            <div className="lm-feature__content-description pt-0">
              <FeatureDescription feature={feature}/>
            </div>
            <div className="lk-feature__price pb-0">
              <div className="lk-feature__price-inner">
                {showQuantityInput ? <GroheFeatureQuantity disabled={!featureIsInStock}
                                                           hideTitle={true}
                                                           feature={feature}
                                                           isWizard={true}/> : null}
                <LookFeaturePairPrice lookFeature={feature}/>
                <GroheFeatureSQFTButton featureOpened={feature} isIcon={true} className="" />
              </div>
              {showPriceInput
                ? <GroheFeatureQuantity disabled={!featureIsInStock} feature={feature} isWizard={true}/>
                : null}
            </div>
          </Fragment>
        )}
        <div className="mt-05 pb-05 flex flex--center empty-none">
          {feature.notAvailableInVisualizer
            ? <GroheFeatureNotInVisualizer/>
            : <LookFeatureRemoveButton lookFeature={feature} isToggle={true}/>}
        </div>
        <div className="grohe-wizard__feature-block">
          <LookFeatureOptions isWizard={true}
                              activeFeature={feature}
                              wizardGroup={wizardGroup} />
        </div>
        <GroheFeatureOptions isWizard={true}
                             activeFeature={feature}
                             wizardGroup={wizardGroup}/>
        {showMatchColor ? <LookFeatureColorMatch/> : null}
      </div>
      {isCompletedStep ? <LookWizardContentFinalPrice/> : null}
    </div>
  )
};

LookWizardContentFeature.propTypes = {
  isCompletedStep: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {canvasCount} = store.bathroomVisualizerState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const {navigationCount} = store.lookState;
  const {filterGroups} = store.filterState;
  const fabricatorData = store.fabricatorState;

  return {
    wizardActiveStep,
    wizardSelectedValues,
    canvasCount,
    isMobile,
    navigationCount,
    visualizersLoadedLength: visualizersLoaded.length,
    filterGroups,
    showMatchColor: document.kvConfig.visualizerType === "bvLook" && !fabricatorData.isEncore,
  };
};

const mapDispatchToProps = {
  setCanvasScale,
  setLookActiveFeature,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardContentFeature)
)
